import classNames from "classnames";
import { FunctionComponent, useCallback } from "react";
import "./style.scss";

interface Props {
  allowPaste?: boolean;
  autocomplete?: "off" | "on";
  autofocus?: boolean;
  name: string;
  onChange?: (value: string) => void;
  pattern?: string;
  placeholder: string;
  required?: boolean;
  submitted: boolean;
  type: "email" | "number" | "password" | "tel" | "text";
  value?: string | number;
}

const Input: FunctionComponent<Props> = ({
  allowPaste = true,
  autocomplete = "on",
  autofocus = false,
  name,
  onChange,
  pattern,
  placeholder,
  required = false,
  submitted,
  type,
  value,
}) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      event.preventDefault();
      if (onChange) {
        onChange(event.target.value);
      }
    },
    [onChange]
  );

  const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  }, []);

  return (
    <div
      className={classNames("Input", {
        "Input--submitted": submitted,
      })}
    >
      <input
        autoComplete={autocomplete}
        autoFocus={autofocus}
        className="Input-input"
        id={name}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onPaste={allowPaste ? () => true : (event) => event.preventDefault()}
        pattern={pattern}
        placeholder="&nbsp;"
        required={required}
        tabIndex={0}
        type={type}
        value={value}
      />
      <label htmlFor={name} className="Input-label">
        {`${placeholder}${required ? "*" : ""}`}
      </label>
    </div>
  );
};

export default Input;
